import { publicData } from "@/utils/publicData";
export const IOSNative = {
  /**
   * @desc 上传回调
   * @param self this 指向
   * @param param json字符串
   * @param callback 回调方法名
   * */
  getComArgsParamPlatIOS: function (self, param, callback) {
    try {
      window.webkit.messageHandlers.getComArgsParamPlat.postMessage({
        params: param,
        callback: callback,
      });
    } catch (error) {
      console.log("getComArgsParamPlatIOS的error", error);
      callback && self[callback](`${publicData.getComArgs}${param ? "&" + param : ""}`);
    }
  },
  /**
   * @desc 上传回调
   * @param data json字符串 {imgCode:图片类型(detail:笔记截图,preview:笔记预览截图)}
   * @param uploadCallback 回调方法名
   * */
  uploadFile: function (data, uploadCallback) {
    try {
      window.webkit.messageHandlers.uploadFile.postMessage(JSON.stringify(data), uploadCallback);
    } catch (error) {
      console.log("上传的error", error);
    }
  },
  /**
   * @desc 保存二维码链接
   * @param qrcodeFilePath 二维码链接
   * */
  saveWxQrcode: function (qrcodeFilePath) {
    try {
      window.webkit.messageHandlers.saveWxQrcodeHandle.postMessage(qrcodeFilePath);
    } catch (error) {
      console.log("保存二维码链接的error", error);
    }
  },
  /**
   * @desc 刷新用户的状态
   * */
  refreshUserInfo: function () {
    try {
      window.webkit.messageHandlers.refreshUserInfo.postMessage(null);
    } catch (error) {
      console.log("刷新用户的状态的error", error);
    }
  },
  /**
   * @desc 埋点
   * @param event 事件代码string
   * @param ext json字符串
   * */
  onEvents: function (event, ext) {
    try {
      window.webkit.messageHandlers.onEvent.postMessage({
        event: event,
        ext: JSON.stringify(ext),
      });
    } catch (error) {
      console.log("埋点调用失败", event, ext, error);
    }
  },

  /**
   * @desc 跳转到新页面
   * */
  toNewPage: function (params) {
    try {
      return window.webkit.messageHandlers.toNewPage.postMessage(params);
    } catch (error) {
      console.log("toNewPage的error", error);
    }
  },

  /**
   * @desc 保存QRCode到相册
   * @param {}
   * @return
   */
  saveQRCodeToAlbum(base64Data) {
    try {
      return window.webkit.messageHandlers.saveQRCodeToAlbum.postMessage(base64Data);
    } catch (error) {
      console.log("存取二维码到相册失败：", error);
      return "0";
    }
  },

  /**
   * @desc 上传File对象
   * @param {}
   * @return
   */
  uploadScreenShot(payload) {
    try {
      return window.webkit.messageHandlers.uploadScreenShot.postMessage(payload);
    } catch (error) {
      console.log("上传截图失败：", error);
      return false;
    }
  },

  /**
   * @desc 获取用户类别
   * @param {}
   * @return
   */
  getUserType(payload = "11") {
    try {
      window.webkit.messageHandlers.getUserType.postMessage(payload);
    } catch (error) {
      console.log("获取用户类别失败", error);
    }
  },

  /**
   * @desc 复制文本到剪切板
   * @param { String } text 需要复制的文本
   * @return
   */
  copyTextToClipboard(text) {
    try {
      window.webkit.messageHandlers.copyTextToClipboard.postMessage(text);
    } catch (error) {
      console.log("复制文本到剪切板失败：", error);
    }
  },

  /**
   * @desc 离开教程页
   * @param {}
   * @return
   */
  leaveIntroducePage(text = '') {
    try {
      window.webkit.messageHandlers.leaveIntroducePage.postMessage(text);
    } catch (error) {
      console.log("离开教程页失败", error);
    }
  },
};
